module.exports = __webpack_public_path__ + "img/Manuel-15.7d38671f.jpg";